import { render, staticRenderFns } from "./IconBigEmptyCart.vue?vue&type=template&id=b07a61a6&scoped=true"
import script from "./IconBigEmptyCart.vue?vue&type=script&lang=js"
export * from "./IconBigEmptyCart.vue?vue&type=script&lang=js"
import style0 from "./IconBigEmptyCart.vue?vue&type=style&index=0&id=b07a61a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07a61a6",
  null
  
)

export default component.exports